import { Injectable, Injector, inject } from "@angular/core";
import { TranslocoMissingHandler } from "@jsverse/transloco";
import { I18nObservabilityService } from "./i18n-observability.service";

// Reports untranslated keys to Sentry via I18nObservabilityService. Replaces Transloco's
// DefaultMissingHandler; it still returns the raw key so the on-screen behaviour is
// unchanged (the app ships a single language, so there is nothing to fall back to).
@Injectable()
export class ReportingMissingHandler implements TranslocoMissingHandler {
    // Resolve the service lazily: this handler is constructed by TranslocoService, which
    // I18nObservabilityService injects — a direct injection would close that DI cycle.
    private readonly injector = inject(Injector);
    // Report each key once per session; Sentry's fingerprint dedups across sessions.
    private readonly seen = new Set<string>();

    // The TranslocoMissingHandler interface passes (key, data, params); we only need the key.
    handle(key: string): string {
        if (!this.seen.has(key)) {
            this.seen.add(key);
            const i18nObservability = this.injector.get(I18nObservabilityService);
            const dotIndex = key.indexOf(".");
            const scope = dotIndex >= 0 ? key.slice(0, dotIndex) : "";
            i18nObservability.reportMissingKey(key, scope, i18nObservability.isScopeLoaded(scope));
        }
        return key;
    }
}
